import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

export interface IListItem {
  dropdownLabel: string;
  dropdownAdditionalDetails?: string;
  id?: number;
}

export interface IInputWithAutocompleteOptions {
  listItems: IListItem[];
  e2eId?: string;
  inputType?: string;
  placeholder?: string;
  id?: string;
  showError?: boolean;
}
export const INPUT_WITH_AUTOCOMPLETE_DEBOUNCE_TIME = 250;

@Component({
  selector: 'app-input-with-autocomplete',
  templateUrl: './input-with-autocomplete.component.html',
  styleUrls: ['./input-with-autocomplete.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: InputWithAutocompleteComponent,
    multi: true
  }]
})

export class InputWithAutocompleteComponent implements ControlValueAccessor, OnInit {

  isActive = false;
  inputValue: string;
  resetTriggered = false;
  inputValueChanges: Subject<string> = new Subject();
  @Input() options: IInputWithAutocompleteOptions;
  @Output() refreshList = new EventEmitter();
  @Output() listItemSelectedEvent = new EventEmitter<IListItem>();

  get listItems(): IListItem[] {
    return this.inputValue && this.options?.listItems ?
      this.options.listItems.filter(item => item.dropdownLabel.toLowerCase().includes(this.inputValue.toLowerCase())) :
      [];
  }

  get e2eId(): string {
    return this.options?.e2eId || '';
  }

  get inputType(): string {
    return this.options?.inputType || 'text';
  }

  get placeholder(): string {
    return this.options?.placeholder || '';
  }

  get id(): string {
    return this.options?.id || '';
  }

  get showError(): boolean {
    return !!this.options?.showError;
  }

  constructor() {
  }

  ngOnInit(): void {
    this.inputValueChanges.pipe(
      debounceTime(INPUT_WITH_AUTOCOMPLETE_DEBOUNCE_TIME),
      distinctUntilChanged((prev, curr) => {
        if (this.resetTriggered) {
          this.resetTriggered = false;
          return false;
        }
        return prev === curr;
      })
    ).subscribe(value => {
      this.refreshList.emit();
      this.isActive = true;
    });
  }

  clickedOutside(): void {
    this.isActive = false;
  }

  inputValueChanged(value: string | null): void {
    this.inputValueChanges.next(value);
    this.writeValue(value);
  }

  listItemSelected(item: IListItem): void {
    this.isActive = false;
    this.writeValue(item.dropdownLabel);
    this.listItemSelectedEvent.emit(item);
  }

  writeValue(value: string): void {
    const oldValue = this.inputValue;
    value = value || '';
    this.inputValue = value;
    this.onChange(value);
    this.onTouch(value);

    if (oldValue && !value) {
      this.resetTriggered = true;
    }
  }

  inputTouched(): void {
    if (!this.inputValue) {
      this.writeValue('');
    }
  }

  onChange: any = () => {};
  onTouch: any = () => {};

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouch = fn; }

}
